import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import InputBox from '@/components/profile/inputBox'
import RoundBlueButton from '@/components/profile/roundBlueButton'
import { listOfSections } from "@/pages/profile/sections/idVerification/constants"

import '@/pages/profile/sections/common.css'

export default function LookingForNote(props: any) {
    const { profile } = useLocalTranslation();

    return (
        <div className='profileSectionOfSectionCommonMainCon'>
            <p className='commonH2'>        
                {profile.fields.whatAreYouLookingFor}
            </p>
            <p className='commonH3'>               
                {profile.placeHolders.pleaseLetUsKnowWhatKindOfCourseOrLearningOpportunityYouInterestedIn}
            </p>

            {props.errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }
            <InputBox
                id={listOfSections.lookingForNote}
                onChange={(e: any) => props.handleInputChange(e, listOfSections.lookingForNote)}
                value={props.value}
                placeholder={profile.placeHolders.pleaseLetUsKnowWhatKindOfCourseOrLearningOpportunityYouInterestedIn2}
            />

            <div className='commonBtnCon1'>
                <RoundBlueButton
                    disabled={props.isSubmitBtnLoading}
                    onClick={() => props.handleSubmit(listOfSections.lookingForNote)}
                />
            </div>
        </div>
    );
}
